<script>
  import Attribution from './Attribution.svelte'

  export let alt
  export let url
  export let attrURL
  export let attrCTA

</script>

<!-- Figure -->
<div 
  data-field-label="Figure"
  class="label | lg:max-w-lg lg:w-full md:w-1/2 w-5/6">
  <img 
    class="object-cover object-center rounded" 
    alt="{alt}" 
    src="{url}">
  <Attribution
    url="{attrURL}"
    cta="{attrCTA}"
  />
</div>
